import React from 'react';
import clsx from 'clsx';
import { isEmpty } from '../../../../../../../utils/utils';
import profileStyles from './UserProfile.module.scss';
import tabStyles from '../../../../ManagementProfileTab/ManagementProfileTab.module.scss';
import type { DrawerRowProps } from './ManagementUserProfile.types';

/** The one label/value row for this drawer, so the dash-when-absent rule and the grid are defined once. */
const DrawerRow = ({ label, value, mutedLabel, title, valueOwnsStyling }: DrawerRowProps) => {
    return (
        <div className={profileStyles.Row}>
            <div className={clsx(profileStyles.Key, { [profileStyles.KeyMuted]: mutedLabel })}>{label}</div>
            <div className={clsx(profileStyles.Value, { [profileStyles.Flex]: !isEmpty(value) && !valueOwnsStyling })} title={title}>
                {isEmpty(value) ? <span className={tabStyles.cellDash}>-</span> : value}
            </div>
        </div>
    );
};

export default DrawerRow;
